// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import DashboardMonitor from "./pages/DashboardMonitor/DashboardMonitor";
import SessionsMonitor from "./pages/SessionsMonitor";
import UssdSummary from "./pages/UssdSummary";
import Login from "./pages/Login";
import { ensureAuthHeader, getUser } from "./services/auth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/* HIERARCHY (SYSTEM SETUP) */
import JimboPage from "./pages/Hierarchy/JimboPage";
import ParokiaPage from "./pages/Hierarchy/ParokiaPage";
import KandaPage from "./pages/Hierarchy/KandaPage";
import JumuiaPage from "./pages/Hierarchy/JumuiaPage";

/* MEMBERS */
import MemberList from "./pages/Members/MemberList";
import MemberCreate from "./pages/Members/MemberCreate";
import MembersPage from "./pages/Members/MembersPage";

/* TRANSACTIONS */
import TransactionsPage from "./pages/Transactions/TransactionsPage";

/* SMS */
import Templates from "./pages/SMS/Templates";
// import SendSMS from "./pages/SMS/SendSMS";
import SMSLogs from "./pages/SMS/SMSLogs";

/* REPORTS */
import ReportsHome from "./pages/Reports/ReportsHome";
import ReportsDashboard from "./pages/Reports/ReportsDashboard";
import TransactionReportPage from "./pages/Reports/TransactionReportPage";
import MemberRegisterReportPage from "./pages/Reports/MemberRegisterReportPage";
import ContributionSummaryReportPage from "./pages/Reports/ContributionSummaryReportPage";
import ChannelSummaryReportPage from "./pages/Reports/ChannelSummaryReportPage";
import CashierReportPage from "./pages/Reports/CashierReportPage";
import SendSMSPage from "./pages/SMS/SendSMSPage";
import CashierPage from "./pages/settings/CashierPage";

export default function App() {
  ensureAuthHeader();
  const user = getUser();

  if (!user) {
    return <Login onLogin={() => window.location.reload()} />;
  }

  return (
    <>
      <Routes>
        {/* MAIN DASHBOARD LAYOUT */}
        <Route path="/" element={<DashboardLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />

          {/* DASHBOARD */}
          <Route path="dashboard" element={<DashboardMonitor />} />
          <Route path="sessions" element={<SessionsMonitor />} />
          <Route path="ussd-summary" element={<UssdSummary />} />

          {/* REPORTS */}
          <Route path="reports">
            <Route index element={<ReportsHome />} />
            <Route path="dashboard" element={<ReportsDashboard />} />
            <Route path="transactions" element={<TransactionReportPage />} />
            <Route path="members" element={<MemberRegisterReportPage />} />
            <Route
              path="contribution-summary"
              element={<ContributionSummaryReportPage />}
            />
            <Route
              path="channel-summary"
              element={<ChannelSummaryReportPage />}
            />
            <Route path="cashier-report" element={<CashierReportPage />} />
          </Route>

          {/* SYSTEM SETUP */}
          <Route path="setup">
            <Route path="jimbo" element={<JimboPage />} />
            <Route path="parokia" element={<ParokiaPage />} />
            <Route path="kanda" element={<KandaPage />} />
            <Route path="jumuia" element={<JumuiaPage />} />
            <Route path="users" element={<CashierPage />} />
          </Route>

          {/* MEMBERS */}
          <Route path="members">
            <Route index element={<MembersPage />} />
          </Route>

          {/* TRANSACTIONS */}
          <Route path="transactions">
            <Route index element={<TransactionsPage />} />
          </Route>

          {/* SMS */}
          <Route path="sms">
            <Route path="templates" element={<Templates />} />
            <Route path="send" element={<SendSMSPage />} />
            <Route path="logs" element={<SMSLogs />} />
          </Route>
        </Route>

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}